<template>
  <div id="app">

    <div v-if="productId === -1 && config.mode.admin === false" style="padding: 20px">

      <h1>Produkt auswählen</h1>

      <select v-model.number="productId">

        <option value="null" disabled>Bitte ein Produkt auswählen...</option>
        <option v-for="product in products" :value.number="product.id">{{product.title}}</option>

      </select>

    </div>

    <component is="ProductConfigurationView" :prodId="productId" v-if="!config.mode.admin && (productId !== null || prodConfigId !== null)"></component>
    <AdminProductConfigurationView v-if="config.mode.admin"></AdminProductConfigurationView>

  </div>
</template>

<script>

  import config from './config';
  import Configuration from './configuration/Configuration';

  import AdminProductConfigurationView from "./views/AdminProductConfigurationView";
  import requestHelper from "./api/requestHelper";

  const view = Configuration.isOverrideCoreModuleWithCustom('./views/ProductConfigurationView') ? './custom/views/ProductConfigurationView' : './views/ProductConfigurationView';

  if (window['w2p_admin'])
    if (window['w2p_admin'] === true) {
      config.mode.admin = true;
      Configuration.getConfig().template.simple = false;
    }

  export default {
    name: 'app',
    data: () => ({
      config,
      prodConfigId: null,
      productId: null,
      products: []
    }),
    components: {
      ProductConfigurationView: () => {
          const view = 'views/ProductConfigurationView';

          if (Configuration.getConfig().template.overrideView === true) {
              return import(`./custom/${view}`);
          } else {
              return import(`./views/ProductConfigurationView`);
          }
      },
      AdminProductConfigurationView
    },
    methods: {
      getParameterByName(name, url = null) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      }
    },
    async mounted() {

      const response = await requestHelper.requestApiRoute('get', '/product', {});

      this.products = response;

      if (window['w2p_prod']) {

        this.productId = window['w2p_prod'].productId || null;

      }

      window['w2p_default_views_by_article_number'] = [ 'A12345' ];

      const productConfigurationId = this.getParameterByName('prodconf');

      if (productConfigurationId) {
        this.prodConfigId = productConfigurationId;
      }

      const prodIdOverride = this.getParameterByName('prodIdOverride');

      if (prodIdOverride) {
        this.productId = prodIdOverride;
      }

      // if (! isNaN(parseInt(productConfigurationId)) )
      //   this.prodConfigId = productConfigurationId;

      String.prototype.interpolate = function(params) {
        const names = Object.keys(params);
        const vals = Object.values(params);
        return new Function(...names, `return \`${this}\`;`)(...vals);
      };

    }
  }

</script>
